export const POST_VIEWED_CHANGED = 'post-viewed-changed';

export const notifyPostViewedChanged = (postId, forumId) => {
    if (typeof window === 'undefined' || postId == null || postId === '') {
        return;
    }
    window.dispatchEvent(new CustomEvent(POST_VIEWED_CHANGED, {
        detail: {
            postId: String(postId),
            forumId: forumId != null ? String(forumId) : '',
        },
    }));
};

export const removePostFromCommunityBadges = (badges, forumId, postId) => {
    if (!badges || typeof badges !== 'object' || Array.isArray(badges)) {
        return badges;
    }
    if (typeof forumId !== 'string' || forumId.length === 0) {
        return badges;
    }
    const arr = badges[forumId];
    if (!Array.isArray(arr)) {
        return badges;
    }
    const postIdStr = String(postId);
    const nextArr = arr.filter((id) => String(id) !== postIdStr);
    if (nextArr.length === arr.length) {
        return badges;
    }
    if (nextArr.length === 0) {
        const next = { ...badges };
        delete next[forumId];
        return next;
    }
    return { ...badges, [forumId]: nextArr };
};

export const countCommunityBadgePosts = (badges) => {
    if (!badges || typeof badges !== 'object' || Array.isArray(badges)) {
        return 0;
    }
    let total = 0;
    for (const key of Object.keys(badges)) {
        const arr = badges[key];
        if (Array.isArray(arr)) {
            total += arr.length;
        }
    }
    return total;
};
